import React from 'react'
import { Level, Logo, Text, withTheme, ThemeProvider, IconManager, ecommerceLogoPack } from '@deseretbook/react-ui'
import { Link } from '../core'

IconManager.register(ecommerceLogoPack)

const StorePickup = ({ theme }) => (
  <ThemeProvider
    theme={{
      typography: {
        dark: theme.typography.light,
      },
    }}
  >
    <Link href="/free-store-pickup" linkRef="nav-free-store-pickup" style={{ maxWidth: '11rem', display: 'flex', alignItems: 'center' }}>
      <Logo name="storePickup" />
    </Link>
  </ThemeProvider>
)

const ThemedNavbarStorePickup = withTheme(StorePickup)

const NavbarStorePickup = () => (
  <ThemeProvider>
    <ThemedNavbarStorePickup />
  </ThemeProvider>
)

export default NavbarStorePickup
